import React from "react";
import "../styles/main.css";
import { Link } from "react-router-dom";

import { Autoplay, Pagination, EffectCoverflow, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function Projects({ innerRef }) {
    const [slidesPerView, setSlidesPerView] = React.useState(2);

    React.useEffect(() => {
        const handleResize = () => {
            setSlidesPerView(window.innerWidth < 768 ? 1 : 2);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section
            className="projects-cont projects"
            ref={innerRef}
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-easing="ease-in-out-quad"
        >
            <h2 className="right">
                <div>
                    <span className="beautify">03. </span>Projects
                </div>
            </h2>

            <Swiper
                effect="coverflow"
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={slidesPerView}
                loop={false}
                pagination={{ clickable: true }}
                navigation={true}
                coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                }}
                modules={[EffectCoverflow, Autoplay, Pagination, Navigation]}
                className="mySwiper"
            >
                {/* PixelPals */}
                <SwiperSlide>
                    <div className="slides">
                        <Link to="https://pixelpals.vercel.app/" className="slide-link">
                            <img src="/img/pixelpals.png" alt="pixel" />
                            <div className="slide-info">
                                <h3>PixelPals</h3>
                                <p>This is a MERN project for a chat app.</p>
                            </div>
                        </Link>
                    </div>
                </SwiperSlide>

                {/* Spotmyfile */}
                <SwiperSlide>
                    <div className="slides">
                        <Link to="https://github.com/heapnotizer/spotmyfile" className="slide-link">
                            <img src="/img/ezgif-43b3efb72f6558e8.gif" alt="spotmyfile" />
                            <div className="slide-info">
                                <h3>Spotmyfile</h3>
                                <p>Find files on your PC based on the content. No need for filenames.</p>
                            </div>
                        </Link>
                    </div>
                </SwiperSlide>

                {/* TaskCraft */}
                <SwiperSlide>
                    <div className="slides">
                        <Link to="https://task-craft-next.vercel.app/" className="slide-link">
                            <img src="/img/taskcraft.png" alt="task" />
                            <div className="slide-info">
                                <h3>TaskCraft</h3>
                                <p>A frontend project for a basic task manager.</p>
                            </div>
                        </Link>
                    </div>
                </SwiperSlide>

                {/* PetSphere */}
                <SwiperSlide>
                    <div className="slides">
                        <Link to="https://petsphere-f.onrender.com/" className="slide-link">
                            <img src="/img/pet.png" alt="pet" />
                            <div className="slide-info">
                                <h3>PetSphere</h3>
                                <p>A MERN project promoting pet adoption.</p>
                            </div>
                        </Link>
                    </div>
                </SwiperSlide>

                {/* Flixio */}
                <SwiperSlide>
                    <div className="slides">
                        <Link to="http://flixio-razor99.vercel.app/" className="slide-link">
                            <img src="/img/flixio.png" alt="flixio" />
                            <div className="slide-info">
                                <h3>Flixio</h3>
                                <p>IMDb clone for exploring movies and TV shows.</p>
                            </div>
                        </Link>
                    </div>
                </SwiperSlide>

                {/* e-Manager */}
                <SwiperSlide>
                    <div className="slides">
                        <Link to="https://e-manager-rho.vercel.app/" className="slide-link">
                            <img src="/img/emanager.png" alt="e-manager" />
                            <div className="slide-info">
                                <h3>e-Manager</h3>
                                <p>Basic web app for CRUD operations.</p>
                            </div>
                        </Link>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    );
}
